// AeroShorts shop: small progressive enhancements. Everything works without JS too.
const still = matchMedia('(prefers-reduced-motion: reduce)').matches;

// Split-flap departure board cycling through words
document.querySelectorAll('[data-flip]').forEach(board => {
  const words = JSON.parse(board.dataset.flip || '[]').map(w => String(w).toUpperCase());
  if (!words.length) return;
  const cells = board.querySelector('.cells');
  const width = Math.min(16, Math.max(...words.map(w => w.length)));
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÜ0123456789-';
  cells.innerHTML = '<i></i>'.repeat(width);
  const slots = [...cells.children];
  const show = word => {
    const text = word.slice(0, width).padEnd(width, ' ');
    slots.forEach((slot, k) => {
      const target = text[k];
      if (still) { slot.textContent = target; return; }
      let steps = 3 + k % 4;
      const tick = () => {
        slot.classList.remove('flip'); void slot.offsetWidth; slot.classList.add('flip');
        slot.textContent = steps-- > 0 ? chars[Math.floor(Math.random() * chars.length)] : target;
        if (steps >= 0) setTimeout(tick, 70);
      };
      setTimeout(tick, k * 35);
    });
  };
  let w = 0;
  show(words[0]);
  if (words.length > 1 && !still) setInterval(() => { w = (w + 1) % words.length; show(words[w]); }, 3200);
});

// Edition picker (EN / DE) inside a buy form: swaps cover, price and title of the chosen edition
document.querySelectorAll('[data-editions]').forEach(form => {
  const root = form.closest('[data-edition-root]') || form;
  const sync = () => {
    const input = form.querySelector('input[name="id"]:checked');
    if (!input) return;
    const d = input.dataset;
    root.querySelectorAll('[data-ed-cover]').forEach(img => { if (d.cover) { img.src = d.cover; img.srcset = ''; img.alt = d.title || img.alt; } });
    root.querySelectorAll('[data-ed-price]').forEach(el => { el.innerHTML = d.price; });
    root.querySelectorAll('[data-ed-link]').forEach(a => { a.href = d.url; });
    root.querySelectorAll('[data-ed-rating]').forEach(el => { el.hidden = el.dataset.edRating !== d.product; });
  };
  form.addEventListener('change', sync);
  sync();
});

// Product gallery thumbnails
document.querySelectorAll('[data-gallery]').forEach(g => {
  const main = g.querySelector('[data-gallery-main]');
  g.querySelectorAll('[data-gallery-thumb]').forEach(btn => btn.addEventListener('click', () => {
    main.src = btn.dataset.src;
    main.srcset = btn.dataset.srcset || '';
    main.alt = btn.dataset.alt || '';
    g.querySelectorAll('[data-gallery-thumb]').forEach(b => b.removeAttribute('aria-current'));
    btn.setAttribute('aria-current', 'true');
  }));
});

// Look inside: open a page preview in a dialog
const lightbox = document.querySelector('[data-lightbox]');
if (lightbox && lightbox.showModal) {
  const img = lightbox.querySelector('img');
  document.querySelectorAll('[data-zoom]').forEach(btn => btn.addEventListener('click', () => {
    img.src = btn.dataset.zoom;
    img.alt = btn.querySelector('img')?.alt || '';
    lightbox.showModal();
  }));
  lightbox.addEventListener('click', e => { if (e.target === lightbox) lightbox.close(); });
}

// Sticky buy bar on phones once the main buy button scrolls out of view
const sticky = document.querySelector('[data-stickybuy]');
const anchor = document.querySelector('[data-buy-anchor]');
if (sticky && anchor && 'IntersectionObserver' in window) {
  new IntersectionObserver(([e]) => {
    sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(anchor);
}

// Cart quantity steppers submit the cart form
document.querySelectorAll('[data-qty]').forEach(box => {
  const input = box.querySelector('input');
  box.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
    input.value = Math.max(0, Number(input.value) + Number(b.dataset.step));
    input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit();
  }));
});

// Theme sale: switch back to regular prices once the sale end has passed (pages can be cached), and run the countdown
const saleEls = document.querySelectorAll('[data-sale-end]');
if (saleEls.length) {
  const ended = el => { const t = Date.parse(el.dataset.saleEnd); return !isNaN(t) && Date.now() >= t; };
  const endSale = () => saleEls.forEach(el => {
    if (!ended(el)) return;
    const on = el.querySelector(':scope > .on'), off = el.querySelector(':scope > .off');
    if (on && off) { on.hidden = true; off.hidden = false; }
    else el.hidden = true;
    if (el.classList.contains('announce')) document.querySelectorAll('.announce.regular').forEach(a => { a.hidden = false; });
  });
  const tick = () => {
    document.querySelectorAll('[data-countdown]').forEach(c => {
      const ms = Date.parse(c.dataset.countdown) - Date.now();
      if (isNaN(ms) || ms <= 0) { c.textContent = ''; return; }
      const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60;
      c.textContent = `${c.dataset.label} ${d ? d + 'd ' : ''}${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m`;
    });
    endSale();
  };
  tick();
  setInterval(tick, 30000);
}
